/**
 * create-conversation — the Keystone conversation create-POST helper (U2
 * extraction from `chat-panel-core.tsx`).
 *
 * Deliberately kept free of the heavy chat-runtime graph. `chat-panel-core.tsx`
 * pulls in `@assistant-ui/react` plus `Thread`, `Composer`, `LibrarySidebar`,
 * and `DurableStreamRuntimeProvider` at its top — exporting this helper from
 * there would drag that graph into the eager shell chunk the moment a
 * shell-level provider (U3) reaches for it (see
 * `plans/flow-chat-multisession/coding-standards.md` §6, "Eager @assistant-ui
 * imports"). This module must never pull in any of those.
 */

import { fetchJson, type ApiFetch } from '../../../lib/apiFetchJson';
import { KeystoneCreateResultSchema, type KeystoneCreateResult } from './useKeystoneChatSession';

/**
 * POST /api/keystone/conversations.
 *
 * `lib/api.ts`'s `apiFetch` combines a caller `signal` with its own timeout,
 * so the signal is passed straight through. Failures surface as
 * `ApiProblemError` (`.status`, and `.message` = the server's detail).
 */
export async function createKeystoneConversation(
  apiFetch: ApiFetch,
  body: { selectedAccountId: string; personaId?: string },
  signal?: AbortSignal,
): Promise<KeystoneCreateResult> {
  return fetchJson(apiFetch, KeystoneCreateResultSchema, '/api/keystone/conversations', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    ...(signal ? { signal } : {}),
  });
}
